import { createContext } from "react";

const SyllabusPdfContext = createContext();

export default SyllabusPdfContext;